import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  UrlTree,
} from '@angular/router';
import { NotifyService } from '@core/notify/notify.service';
import { SessionService } from '@core/state/session.service';
import { LocalStorageService } from '@core/state/local-storage.service';

@Injectable({ providedIn: 'root' })
export class validateTransferGuard implements CanActivate {
  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: Object,
    private readonly router: Router,
    private readonly session: SessionService,
    private readonly notify: NotifyService,
    private readonly storage: LocalStorageService
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    if (!isPlatformBrowser(this.platformId)) return true;

    let t =
      route.queryParamMap.get('t') ?? route.queryParamMap.get('token');
    if (t) t = t.trim().replace(/^"+|"+$/g, '');
    if (!t) return true;

    if (t.length < 20) {
      this.notify.error('Token de transferência inválido ou expirado.');
      return this.router.createUrlTree(['/login']);
    }

  
    this.storage.set('transfer_redirect_token', t);

    const cleanUrl = (): UrlTree => {
      const u = new URL(state.url, window.location.origin);
      u.searchParams.delete('t');
      u.searchParams.delete('token');
      const clean = u.pathname + (u.search || '') + (u.hash || '');
      return this.router.parseUrl(clean);
    };

    const attemptedKey = `transfer_t:${t}`;
    if (sessionStorage.getItem(attemptedKey)) {
      return cleanUrl();
    }
    sessionStorage.setItem(attemptedKey, '1');

    try {
      await this.session.validateTransferToken(t);
      return cleanUrl();
    } catch {
      this.notify.error('Token de transferência inválido ou expirado.');
      return this.router.createUrlTree(['/login']);
    }
  }
}
